/**
 * @info
 *
 * *The "store/global" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind global functionality.
 *
 * *This file*
 * This file outlines "state". This is the starting snapshot
 * of the modules underlying state. As the user interacts with
 * the components tied into this Vuex module, this state is modified
 * away from these default values.
 */
export default {
  cart: window.__GLOBAL__?.cart,
  modal: { current: '' },
  backInStock: {
    product: {},
    variant: {},
  },
  isMobile: window.innerWidth < 768,
  customer: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    birthDay: '',
    birthMonth: '',
    shade: '',
  },
  gwp: {
    loading: false,
    productDelimiter: '',
    layout: false,
    onlyOneProduct: false,
    active: false,
    collection: false,
    collection_data: null,
    collectionUpsellDismissed: !!window.sessionStorage.getItem('gwpCollectionUpsell'),
    limit: 0,
    rewardHandle: '',
    rewardCollection: false,
    rewardLimit: 0,
    userSelection: [],
    userAltSelection: [],
  },
  // Metaobject-based promotions (new system)
  promotions: {
    gwp: [],
    samples: [],
    loaded: false,
    loading: false,
    error: null,
  },
  UGC: {
    sliderExists: false,
  },
  shippingRestrictedItem: null,
  activeCountryCode: false,
  currentProductGalleryVideo: {
    src: null,
  },

  marketRecommendation: null,
};
